<template lang="pug">
    .div
        model-form(
            ref="form"
            reset-text="restablecer"
            submit-text="guardar"
            title="Datos del proveedor"
            v-bind='formProps'
            v-model='formData'
            @reset='reset'
            @submit='submitForm'
        )
        v-divider
        branch-offices-list.pa-0( :items='listItems' @success='reset' )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { ModelForm } from '@/components/reusable_components/next'
import { BranchOfficesList } from '@/components/lists'
//
import ProviderService from '@/services/api/provider/ProviderService'
import ProviderModel from '@/models/Purchase/PchProvider'
//
import ProviderInformationFields from './form/ProviderInformationFields'
//
export default {
    name: 'provider-information',
    components: {
        BranchOfficesList,
        ModelForm,
    },
    computed: {

        /**
         *
         */
        formProps() {
            return {
                fields: ProviderInformationFields,
                loading: this.formBusy,
                editable: !this.$can('EDIT_PURCHASE_PROVIDER'),
                switchEdit: this.$can('EDIT_PURCHASE_PROVIDER'),
                readOnly: !this.$can('EDIT_PURCHASE_PROVIDER'),
            }
        },
    },    
    data() {
        return {
            formBusy: false,
            formData: {},
            listItems: [],
        }
    },
    methods: {

        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        busy() {
            this.formBusy = !this.formBusy
        },

        /**
         *
         */
        fetch() {
            ProviderModel.modeler().find(this.$route.params.id).finally(this.busy).then(this.setFormData)
        },

        /**
         * 
         */
        reset() {
            this.busy()
            this.fetch()
        },

        /**
         *
         */
        setFormData(model) {
            this.formData = model
            this.listItems = model.branch_offices
            this.listItems = [...this.listItems]
        },

        /**
         *
         */
        async submitForm(data) {
            //
            data.branch_offices = this.listItems

            let response = await data.save()

            if (response.status === 'success') {
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El cliente fue editado exitosamente',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
                this.$router.push('/providers')
            } else {
                let snackInfo = this.fillSnack(
                    'success',
                    'Error',
                    '',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },
    },
    //mixins: [InputValidations, CurrencyUtils],
    mounted() {
        this.reset()
        this.setTitleTopBar('Detalle del proveedor')
    },
}
</script>
